import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { MaterialRequestEntity } from './material-request-entity';
import { MaterialRequestRepository } from './material-request-repo';
import { MaterialRequestService } from './material-request-service';
import { MaterialRequestController } from './material-request-controller';
import { ApplicationExceptionHandler } from 'packages/backend-utils/src/lib/exception-handling/application-exception-handler';
import { StockInRepository } from '../stock-in/repositories/stock-in.repository';
import { StockInEntity } from '../stock-in/entities/stock-in.entity';



@Module({
  imports:[TypeOrmModule.forFeature([MaterialRequestEntity,StockInEntity])],
  controllers: [MaterialRequestController],
  providers: [MaterialRequestService,ApplicationExceptionHandler,MaterialRequestRepository,StockInRepository]
})
export class MaterialRequestModule {}
